export default "__VITE_ASSET__BgHgjBfE__"